<template>
    <div v-if="options_pending || available_dates_pending" class="d-flex align-items-center justify-content-center">
        <BSpinner small/> {{ t('Loading') }}...
    </div>
    <div v-else>
    <BForm>
        <BFormRow>
            <BCol cols="12" md="6" lg="6">
                <label for="name" class="form-label">{{ t('Contacts') }}</label>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.full_name?.join(', ')" :state="errors.full_name ? false : null">
                    <BFormInput v-model="formdata.full_name" :placeholder="t('Full name')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.email?.join(', ')" :state="errors.email ? false : null">
                    <BFormInput v-model="formdata.email" :placeholder="t('Email')" type="email"/>
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.phone?.join(', ')" :state="errors.phone ? false : null">
                    <BFormInput v-model="formdata.phone" :placeholder="t('Phone number')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.social_network?.join(', ')" :state="errors.social_network ? false : null">
                    <BFormInput v-model="formdata.social_network" :placeholder="t('Social network')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.birth_date?.join(', ')" :state="errors.birth_date ? false : null">
                    <BFormInput v-model="formdata.birth_date" :placeholder="t('Birth date')" type="date" />
                </BFormGroup>
            </BCol>


            <BCol cols="12" md="12" lg="12" class="mb-3">
                <label for="message" class="form-label mt-4">{{ t('Your skills') }}</label>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.langs?.join(', ')" :state="errors.langs ? false : null">
                    <BFormInput v-model="formdata.langs" :placeholder="t('Languages')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.education?.join(', ')" :state="errors.education ? false : null">
                    <BFormInput v-model="formdata.education" :placeholder="t('Education')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.cultural_experience?.join(', ')" :state="errors.cultural_experience ? false : null">
                    <BFormInput v-model="formdata.cultural_experience" :placeholder="t('Cultural education')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.experience?.join(', ')" :state="errors.experience ? false : null">
                    <BFormInput v-model="formdata.experience" :placeholder="t('Experience in the field of culture')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12">
                <BFormGroup :invalid-feedback="errors.volunteering_experience?.join(', ')" :state="errors.volunteering_experience ? false : null">
                    <BFormInput v-model="formdata.volunteering_experience" :placeholder="t('Volunteering experience')" />
                </BFormGroup>
            </BCol>


            <BCol cols="12" md="12" lg="12" class="mb-3 mt-4">
                <label for="message" class="form-label mt-4">{{ t('Volunteering at the fair') }}</label>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.expections?.join(', ')" :state="errors.expections ? false : null">
                    <BFormInput v-model="formdata.expections" :placeholder="t('What do you expect from participating in the event?')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.how_know?.join(', ')" :state="errors.how_know ? false : null">
                    <BFormInput v-model="formdata.how_know" :placeholder="t('How do you know about Cosmoscow?')" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.direction?.join(', ')" :state="errors.direction ? false : null">
                    <BFormSelect v-model="formdata.direction" :options="directions_selections" class="color-gray" />
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3 d-flex align-items-center">
                <BFormGroup :invalid-feedback="errors.team_leader?.join(', ')" :state="errors.team_leader ? false : null">
                    <BFormCheckbox v-model="formdata.team_leader" class="color-gray">{{ t('I want to become a team leader') }}</BFormCheckbox>
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="6" lg="6" class="mb-3">
                <BFormGroup :invalid-feedback="errors.size?.join(', ')" :state="errors.size ? false : null">
                    <BFormSelect v-model="formdata.size" :options="sizes_selections" class="color-gray"/>
                </BFormGroup>
            </BCol>


            <BCol cols="12" md="12" lg="12">
                <label class="form-label mt-4">{{ t('When are you ready to help at the nearest fair?') }}</label>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3">
                <BFormGroup :invalid-feedback="errors.dates?.join(', ')" :state="errors.dates ? false : null">
                    <BFormCheckbox 
                        class="color-gray"
                        inline v-model="formdata.dates"  
                        v-for="available_date in available_dates" 
                        :key="available_date" 
                        :value="available_date">
                            {{ $dayjs(available_date).locale(locale).format('DD MMMM') }}
                    </BFormCheckbox>
                </BFormGroup>
            </BCol>
            <BCol cols="12" md="12" lg="12" class="mb-3 mt-4">
                <BFormGroup :invalid-feedback="errors.agreement?.join(', ')" :state="errors.agreement ? false : null">
                    <BFormCheckbox v-model="formdata.agreement" id="agreement">
                        <label for="agreement" class="color-gray">
                            <NuxtLink :to="localePath('/privacy_agreement/')" 
                            target="_blank" 
                            class="color-gray"
                            style="text-decoration:underline">{{ t('Consent') }}</NuxtLink>

                            {{t('to the')}}
                            
                            <NuxtLink :to="localePath('/legal/privacy_policy/')" target="_blank" class="color-gray" style="text-decoration:underline">
                                {{ t('Policy on the Processing of Personal Data') }}
                            </NuxtLink>
                        </label>
                    </BFormCheckbox>
                </BFormGroup>
            </BCol>

            <BCol cols="12" md="12" lg="12" class="mb-3 mt-4">
                <BButton variant="dark" class="w-100" @click="submitForm" size="lg" :disabled="formSending">
                    <BSpinner v-if="formSending" small />
                    {{ t('Send application') }}
                </BButton>
            </BCol>
        </BFormRow>

        <BModal ref="ok_modal" :title="t('Application sent')" :no-footer="true">
            <p>{{ t('Your application has been sent') }}</p>
        </BModal>

    </BForm>
    </div>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const { $apiFetch } = useNuxtApp()
const localePath = useLocalePath()

const formdata = ref({
    direction: null,
    size: null,
    dates: [],
    agreement: false,
})

const { data: options, pending: options_pending, error: options_error } = await useAsyncData('options', async () => {
    return await $apiFetch(`/${locale.value}/api/site/volunteers/`, {
        method: 'OPTIONS',
    })
})

const {data: available_dates, pending: available_dates_pending, error: available_dates_error} = await useAsyncData('available_dates', async () => {
    return await $apiFetch(`/${locale.value}/api/site/volunteers/available_dates/`, {
        method: 'GET',
    })
})

const directions_selections = computed(() => {
    return [
        {
            value: null,
            text: t('Directions'),
            disabled: true
        },
        ...options.value.actions.POST?.direction?.choices?.map((item: any) => {
        return {
            value: item.value,
            text: item.display_name,
            disabled: false
        }
    })
    ]
})

const sizes_selections = computed(() => {
    return [
        {
            value: null,
            text: t('Choose your T-shirt size'),
            disabled: true
        },
        ...options.value.actions.POST?.size?.choices?.map((item: any) => {
        return {
            value: item.value,
            text: item.display_name,
            disabled: false
        }
    })
    ]
})

// Processing form data
const formSending = ref(false)
const errors = ref({})
const ok_modal = ref(null)

const submitForm = async () => {
    errors.value = {}
    formSending.value = true
    try {
        await $apiFetch(`/${locale.value}/api/site/volunteers/`, {
            method: 'POST',
            body: formdata.value,
        })
        ok_modal.value.show()
        errors.value = {}
        formdata.value = {}
    } catch (e) {
        if (e.data) {
            errors.value = e.data
        } else {
            errors.value = {}
        }
    } finally {
        formSending.value = false
    }
}

</script>

<i18n lang="json">
{
    "ru": {
        "Contacts": "Контактная информация",
        "Your skills": "Ваши навыки",
        "Full name": "ФИО",
        "Email": "Email",
        "Phone number": "Номер телефона",
        "Social network": "Социальная сеть",
        "Languages": "Языки",
        "Education": "Образование",
        "Cultural education": "Культурное образование",
        "Experience in the field of culture": "Опыт в сфере культуры",
        "Volunteering experience": "Опыт волонтерства",
        "Volunteering at the fair": "Волонтерство на ярмарке",
        "What do you expect from participating in the event?": "Что вы ожидаете от участия в мероприятии?",
        "How do you know about Cosmoscow?": "Откуда вы узнали о Cosmoscow?",
        "I want to become a team leader": "Хочу стать тим-лидером",
        "When are you ready to help at the nearest fair?": "В какие дни вы готовы помочь на ближайшей ярмарке?",
        "Send application": "Отправить заявку",
        "Consent": "Согласен(на)",
        "to the": "с",
        "Policy on the Processing of Personal Data": "Политикой в отношении обработки персональных данных",
        "Directions": "Направления деятельности",
        "Choose your T-shirt size": "Выберите размер футболки",
        "Application sent": "Заявка отправлена",
        "Your application has been sent": "Ваша заявка была отправлена",
        "Birth date": "Дата рождения"
    }
}
</i18n>

<style lang="scss" scoped>
.form-label {
    margin-top: 3rem;
    font-weight: 600;
    &:first-child {
        margin-top: 0;
    }
}
.color-gray {
    color: #6c757d;
}
</style>